module.exports = __webpack_public_path__ + "static/kv-1f4159d9b722b1f8126df771730a4fab.png";